module.exports = __webpack_public_path__ + "img/icon.700406f7.png";